// AUTO-GENERATED by scripts/convert-rn-icons.ts from libs/component-library/src/lib/icons/icons.tsx - do not edit.
import { FxSvg, type FxSvgProps } from '../FxSvg.js';

export const FxArrowUpIcon = (props: FxSvgProps) => (
  <FxSvg width={24} height={24} viewBox="0 0 24 24" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M20.5303 12.5303C20.8232 12.2374 20.8232 11.7626 20.5303 11.4697L12.5303 3.46967C12.2374 3.17678 11.7626 3.17678 11.4697 3.46967L3.46967 11.4697C3.17678 11.7626 3.17678 12.2374 3.46967 12.5303C3.76256 12.8232 4.23744 12.8232 4.53033 12.5303L11.25 5.81066L11.25 20C11.25 20.4142 11.5858 20.75 12 20.75C12.4142 20.75 12.75 20.4142 12.75 20L12.75 5.81066L19.4697 12.5303C19.7626 12.8232 20.2374 12.8232 20.5303 12.5303Z"
    />
  </FxSvg>
);
